/** ru 国家/地区落地页 */
export default {
  "label": "Russia",
  "path": "/locations/free-russia-vpn/",
  "hreflang": "ru",
  "htmlLang": "ru",
  "title": "Secure VPN – Бесплатный VPN с российским IP",
  "description": "Используйте Secure VPN, чтобы защитить интернет-соединение и узнать, как получить российский IP-адрес. Проверьте доступные серверы и настройте подключение.",
  "h1": "Бесплатный VPN с российским IP-адресом",
  "heroLead": "Скачайте Secure VPN и получите быстрое зашифрованное соединение для браузера, стриминга, игр и защиты личных данных в интернете.",
  "heroPoints": [
    "1 устройство под защитой",
    "Без логов и рекламы",
    "Безлимитно и бесплатно",
    "Глобальные VPN-серверы"
  ],
  "heroCtaLabel": "Скачать APK",
  "privacyTitle": "Защитите приватность с бесплатным VPN",
  "privacyLead": "Secure VPN — это простое VPN-приложение, которое помогает сохранять приватность в интернете. Одним касанием вы подключаетесь к защищённому серверу, скрываете IP-адрес и безопаснее пользуетесь общественным Wi-Fi, мобильной сетью или домашним интернетом. Приложение подходит пользователям, которым нужна быстрая защита без сложных настроек.",
  "privacySubtitle": "Ключевые преимущества",
  "privacyBenefits": [
    {
      "title": "Бесплатно и без лимитов",
      "desc": "Пользуйтесь VPN без ежедневных ограничений трафика и скрытых платежей."
    },
    {
      "title": "Защита в общественном Wi-Fi",
      "desc": "Безопаснее пользуйтесь сетями в кафе, аэропортах, отелях и других общественных местах."
    },
    {
      "title": "Политика без логов",
      "desc": "Мы не храним историю посещённых вами сайтов во время использования VPN."
    }
  ],
  "featuresTitle": "Что даёт бесплатный VPN от Secure?",
  "featureCards": [
    {
      "title": "Зашифрованная защита",
      "desc": "Защитите личные данные и интернет-трафик с помощью надёжного шифрования."
    },
    {
      "title": "Быстрые серверы по миру",
      "desc": "Подключайтесь к скоростным VPN-серверам для браузера, видео и повседневных задач."
    },
    {
      "title": "Много локаций",
      "desc": "Выбирайте серверы в разных странах и сохраняйте стабильное соединение."
    },
    {
      "title": "Подключение одним касанием",
      "desc": "Мгновенно подключайтесь к лучшему доступному серверу без сложной настройки."
    },
    {
      "title": "Серверы по всему миру",
      "desc": "Быстрый и надёжный доступ к глобальным VPN-серверам в любое время."
    },
    {
      "title": "Плавный стриминг",
      "desc": "Смотрите видео и трансляции через стабильное соединение без лишних задержек."
    },
    {
      "title": "Высокая скорость",
      "desc": "Оптимизированные серверы обеспечивают стабильную работу браузера и игр."
    },
    {
      "title": "Бесплатно и без лимитов",
      "desc": "Пользуйтесь VPN без ежедневных ограничений трафика и скрытых платежей."
    }
  ],
  "extraTitle": "Ещё причины выбрать Secure VPN",
  "extraItems": [
    "Лёгкий и понятный",
    "Защита в общественном Wi-Fi",
    "Скрытие IP-адреса",
    "Интернет без лишних ограничений",
    "Стабильные серверы"
  ],
  "extraCta": "Скачать APK",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "Как Secure VPN вписывается в повседневную жизнь",
  "dailyScenes": [
    {
      "title": "Игры без сетевых ограничений",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "Приватные звонки и сообщения",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "Связь через общественный Wi-Fi",
      "tags": [
        "Общественный Wi-Fi",
        "Рабочие сети",
        "Учебные сети",
        "Аэропорты"
      ]
    },
    {
      "title": "Защита личных данных",
      "tags": [
        "Надёжное шифрование",
        "Скрытие IP-адреса",
        "Политика без логов",
        "Защита от провайдера"
      ]
    }
  ],
  "installTitle": "Как скачать и установить приложение Secure VPN",
  "installLead": "Следуйте этим простым шагам:",
  "installSteps": [
    {
      "title": "Откройте страницу загрузки",
      "desc": "Перейдите на страницу загрузки Secure VPN или в доверенный магазин приложений, чтобы получить последнюю версию."
    },
    {
      "title": "Скачайте Secure VPN",
      "desc": "Нажмите Скачать и дождитесь завершения загрузки APK или файла приложения."
    },
    {
      "title": "Разрешите установку",
      "desc": "При установке APK включите для браузера или файлового менеджера разрешение Установка неизвестных приложений."
    },
    {
      "title": "Установите приложение",
      "desc": "Откройте загруженный файл, нажмите Установить и завершите установку."
    },
    {
      "title": "Откройте и подключитесь",
      "desc": "Запустите Secure VPN, выберите сервер и нажмите Подключить, чтобы начать защищённое соединение."
    },
    {
      "title": "Пользуйтесь безопасно",
      "desc": "Теперь трафик защищён. Смотрите видео, играйте и пользуйтесь общественным Wi-Fi безопаснее."
    }
  ],
  "installCta": "Скачать APK",
  "compareTitle": "Приложение Secure VPN и бесплатный веб-прокси",
  "compareLead": "VPN-приложение и бесплатный веб-прокси помогают повысить приватность, но работают по-разному. VPN защищает всё устройство и шифрует соединение, а веб-прокси в основном предназначен для быстрого доступа через браузер.",
  "compareNote": "Для повседневной работы в интернете Secure VPN даёт более полное и надёжное защищённое соединение.",
  "compareHeaders": [
    "Возможность",
    "Приложение Secure VPN",
    "Бесплатный веб-прокси"
  ],
  "compareRows": [
    {
      "feature": "Установка",
      "vpn": "Простая установка приложения",
      "proxy": "Установка не требуется"
    },
    {
      "feature": "Использование",
      "vpn": "Защищает приложения и сайты",
      "proxy": "Работает только в браузере"
    },
    {
      "feature": "Приватность",
      "vpn": "Надёжное шифрование и защита",
      "proxy": "Базовый уровень приватности"
    },
    {
      "feature": "Скорость",
      "vpn": "Оптимизированные VPN-серверы",
      "proxy": "Зависит от прокси-сервера"
    },
    {
      "feature": "Защита устройства",
      "vpn": "Защищает всё устройство",
      "proxy": "Только уровень браузера"
    }
  ],
  "privacyChoiceTitle": "Что выбрать?",
  "privacyChoiceP1": "если нужны усиленная приватность, высокая скорость и защита всего устройства.если нужны усиленная приватность, высокая скорость и защита всего устройства.",
  "privacyChoiceP2": "если нужен временный доступ через браузер для простых задач.",
  "privacyChoiceP3": "Для повседневной работы в интернете Secure VPN даёт более полное и надёжное защищённое соединение.",
  "reviewsTitle": "Нам доверяют пользователи",
  "reviewsLead": "Пользователи по всему миру выбирают Secure VPN за быстрое, стабильное и безопасное соединение. Надёжные серверы и защита приватности помогают безопасно смотреть видео, играть и оставаться на связи.",
  "reviews": [
    {
      "name": "James",
      "text": "Быстрое соединение и простое управление. Я безопасно работаю в интернете где угодно."
    },
    {
      "name": "Emily",
      "text": "Secure VPN стабильно работает и сохраняет соединение в общественном Wi-Fi."
    },
    {
      "name": "Daniel",
      "text": "Хорошая скорость и надёжные серверы для видео, игр и повседневных задач."
    }
  ],
  "faqTitle": "Частые вопросы",
  "faqs": [
    {
      "q": "Замедляет ли VPN интернет?",
      "a": "VPN может немного снизить скорость, так как трафик проходит через защищённый сервер. Обычно разница незаметна, и сайты, видео и приложения работают нормально."
    },
    {
      "q": "Безопасно ли пользоваться SecureVPN?",
      "a": "SecureVPN шифрует соединение и скрывает IP-адрес. Скачивайте приложение только из доверенных источников и проверяйте политику конфиденциальности."
    },
    {
      "q": "Законно ли использовать VPN?",
      "a": "В большинстве стран VPN разрешён и используется для приватности и безопасности. Соблюдайте законы и правила вашего региона."
    },
    {
      "q": "Как долго можно оставаться подключённым?",
      "a": "Вы можете использовать SecureVPN столько, сколько нужно защищённое соединение. Ограничения зависят от версии приложения и условий сервиса."
    },
    {
      "q": "Как пользоваться Secure VPN?",
      "a": "Установите Secure VPN, откройте приложение, при необходимости выберите сервер и нажмите кнопку подключения."
    },
    {
      "q": "Влияет ли VPN на батарею?",
      "a": "VPN расходует немного дополнительной энергии, поскольку соединение остаётся активным. В большинстве случаев влияние минимально."
    }
  ]
};
